<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-kid-from-port-douglas">
<p style="text-align: center; padding-top:120px;"><img alt="" src="media/file0.jpg" style="width:4.63in;height:3.19167in"/></p><br/>
<p style="text-align: center;">When the Cobb and Co coach returned to port Douglas in the early sixties, Grandma was not to be denied the experience as she was born hardly 100 meters from where the coach stood. My sister and I accompanied her in the coach. It was a special day.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?46ab5c98